/** Mask an API key for display while keeping copy/delete on the full value. */

export function maskApiKey(value) {
  const key = String(value ?? '').trim()
  if (!key) return '—'
  if (key.length <= 8) return `${key.slice(0, 2)}••••${key.slice(-2)}`
  return `${key.slice(0, 8)}••••${key.slice(-4)}`
}
